export const globalData = {
  phone: "+32 3 5350888",
  phoneHeadIcon: "img/vector--stroke-.svg",
  headLogo1024: "img/logo-01-4.svg",
  footLogo: "img/logo-01-5.svg",
  footLogo2: "img/logo-02-3.svg",
  footBg: "img/rectangle-18.png",
  aboutAlgt: "ABOUT ALGT",
  ourReports: "OUR REPORTS",
  newsLibrary: "NEWS & LIBRARY",
  service: "SERVICE",
  video: "VIDEO",
  place: "CONTACT",
  allRightsReserved: "© 2023 ALGT. ALL RIGHTS RESERVED.",
  email: "info@algtlabs.com",
  emailName: "Mail:",
  emailIcon: "img/union-3.svg",
  emailHeadIcon: "img/vector-1.svg",
  time: "Monday to Friday - 9.30am to 17.30pm",
  timeName: "Business hours:",
  timeIcon: "img/vector-5.svg",
  follow: "Follow Me",
  facebookName: "Facebook",
  facebookUrl: "https://www.facebook.com/algtlabs",
  // facebookUrl: "https://www.baidu.com",
  facebookIcon: "img/vector-45.svg",
  instagramName: "Instagram",
  instagramUrl: "https://www.instagram.com/algt.antwerp",
  // instagramUrl: "https://www.163.com",
  instagramIcon: "img/vector-46.svg",
  wechatName: "Wechat 公众微信号",
  wechatIcon: "img/vector-47.svg",
  redBookName: "小红书官方账号",
  redBookUrl: "https://www.xiaohongshu.com/user/profile/61246c5000000000010155bf",
  redBookIcon: "img/union-6.svg",
  algtReportPriceListPdf: "pdf/ALGT Report Price List 2025.pdf",
  customerRegistrationFormPdf: "pdf/Customer Registration Form.pdf",
};

export const homeData = {
  overlapGroup6: "img/rectangle-21.png",
  overlapGroup7: "img/algt-00.gif",
  reportNumber: "Report Number",
  aboutAlgt: "ABOUT ALGT",
  theGemstoneMarket: `The Gemstone market is constantly changing and in motion. The techniques and technology to create mitations, synthetics (‘laboratory-grown’ or ‘lab-grown’) or to artificially alter the appearance of diamonds and gemstones are rapidly evolving and increasingly more difficult to detect. For consumers and professionals, it has become virtually impossible to separate one from another. However, there can be substantial differences in value. That is why the diamond, gemstone and jewellery market need professional gemstone testing laboratories to ensure trust and confidence between seller and buyer.`,
  moreDetails: "More Details",
  rectangle: "img/rectangle-10.png",
  overlapGroup1: "img/algt-53.gif",
  overlapGroup2: "img/rectangle-43.png",
  maskGroup1: "img/mask-group@2x.png",
  name1: "Segers Marc",
  founder1: "FOUNDER",
  theCaratColorCl1: "IGI GG, HRD GG, ACAM GG, FEEG EG",
  maskGroup2: "img/mask-group-1@2x.png",
  text6: "Mingyue Yang",
  founder2: "FOUNDER",
  theCaratColorCl2: "MSc, IGI GG, ACAM GG, FEEG EG",
  whyChooseAlgt: "WHY CHOOSE ALGT",

  highlyQualifiedProfessionals: 'Highly Qualified <br />Professionals',
  latestTechnology: "Latest Technology",
  totalTransparency: "Total Transparency",
  x5StarServices: "5-star Services",
  fastTurnaroundTime: "Fast Turnaround Time",
  competitivePrices: "Competitive Prices",
  guaranteedPeaceOf: "Guaranteed Peace of Mind for Traders or Consumers alike",

  title: "OUR REPORTS",
  name2: "DIAMOND REPORT",
  theCaratColorCl3: "The carat, color, clarity and cut – commonly known as the 4C’s of each diamond are clearly stated on each diamond report.",
  rectangle36: "img/gemstone-report.jpeg",
  gemstoneReport: "GEMSTONE REPORT",
  theCertificateIden1: "The report identifies the species and variety of the gemstone, shape & cutting style, carat weight, color quality & trade name, measurements, transparency factor and major optical characteristics.",
  name3: "PEARL REPORT",
  theCaratColorCl4: "Including：Quantity，Weight，Size，Shape，Color（Body Color & Overtone)，Pearl Type, Mollusk, Treatments, Lustre, Surface Quality.",
  rectangle38: "img/pearl-report.jpeg",
  rectangle37: "img/lab-grown-diamond-report.png",
  labGrownDiamondReport: "LABORATORY-GROWN DIAMOND REPORT",
  theCertificateIden2: "ALGT’s LABORATORY-GROWN DIAMOND grading reports provide the 4C’s and producing method.",
  premiumReport: "PREMIUM REPORT",
  encasedInALushTr: "Encased in a lush trifold leather folder, the Premium Report is a three-page report containing information that caters specifically to your gemstone or jewellery set. Aarge blow-up photo in top-quality resolution rests between a factsheet and anarticle on your item.",
  rectangle44: "img/hardcover-certificate-cover.jpg",
  service: "SERVICE",
  laseInscription1: "img/lase-inscription-1.png",
  laseInscription: "LASER INSCRIPTION",
  quickCheck1: "img/quick-check-1--1.png",
  quickCheck: "QUICK CHECK",
  seal1: "img/seal-1.png",
  seal: "SEAL",
  globalData: globalData,
};

export const aboutData = {
  globalData: globalData,
  title: "ABOUT US",
  theGemstoneMarket: "The Gemstone market is constantly changing and in motion. The techniques and technology to create imitations, synthetics (‘laboratory-grown’ or ‘lab-grown’), or to artificially alter the appearance of diamonds and gemstones are rapidly evolving and increasingly more difficult to detect. For consumers and professionals, it has become virtually impossible to separate one from another. However there can be substantial differences in value. That is why the diamond, gemstone and jewellery market need professional gemstone testing laboratories to ensure trust and confidence between seller and buyer.",
  antwerpLaboratoryF: "Antwerp Laboratory for Gemstone Testing（ALGT） located in Antwerp, Belgium is an independent international laboratory specializing in diamond, gemstone, jewelry and watch identification, quality analysis and evaluation. ALGT provides detailed identification and enhancement reports and country-of-origin reports.",
  algtIsEquippedWit: "ALGT is equipped with the latest high-tech analytical instruments and uses the most advanced grading and identification techniques available, in accordance to worldwide accepted industry standards, and it is constantly upgrading and updating its instruments and staff following the latest market’s developments and publications.",
  ourTeamOfGemmolog: "Our team of gemmologists consists out of highly qualified and trained industry experts with decades of experience and a worldwide reputation to make sure that we can provide our clients with total disclosure on our reports. Every certificate issued by ALGT carries a unique certificate number that can be tracked online. With the help of Verify Report option on ALGT.com website, consumers can easily track and verify their ALGT certificates.",
  ourGoalIsToAccom:  "Our goal is to accommodate and assist the professional gemstone, jewellery and diamond dealer, while at the same time providing protection and assurance towards the end consumers.",
  image9: "img/image-9-2@2x.png",
  dsc42851: "img/-dsc4285-1.png",
  dsc428512: "img/-dsc4285-1-1.png",
  ramanPl2: "img/raman-pl-2.jpeg",
  rectangle73: "img/rectangle-73.png",
  rectangle74: "img/rectangle-74.png",
  overlapGroup: "img/banner-1920.png",
};

export const typesData = {
  className: "group-11-1",
  tag21Props: { text5: "总部实验室近期参加的活动" },
  tag22Props: { text5: "中国实验室近期参加的活动" },
  tag23Props: { text5: "钻石研究文章" },
  tag24Props: { text5: "彩色宝石研究文章" },
  tag25Props: { text5: "珍珠研究文章" },
  tag26Props: { text5: "翡翠研究文章" },
  tag27Props: { text5: "宝石内含物" },
};

export const frame1Data = {
  rectangle69: "img/rectangle-69@2x.png",
  name: "总部实验室活动",
  className: "rectangle-69-1",
  intro:
    "Encased in a lush trifold leather folder, the Premium Report is a three-page report containing information that caters specifically to your gemstone or jewellery set. Aarge blow-up photo in top-quality resolution rests between a factsheet and anarticle on your item.",
  tag2Props: { text5: "总部实验室近期参加的活动", className: "tag-3" },
};
export const frame2Data = {
  rectangle69: "img/rectangle-69-4.png",
  name: "实验室培育钻石的检测步骤",
  className: "rectangle-69-2",
  intro:
    "The certificate identifies the variety of the gemstone, shape & cutting style, carat weight, color quality & trade name, measurements, transparency factor and major optical characteristics.",
  tag2Props: { text5: "钻石研究文章", className: "tag-4" },
};
export const frame3Data = {
  rectangle69: "img/rectangle-85.png",
  name: "DIAMOND REPORT",
  className: "rectangle-69-3",
  intro:
    "Encased in a lush trifold leather folder, the Premium Report is a three-page report containing information that caters specifically to your gemstone or jewellery set. Aarge blow-up photo in top-quality resolution rests between a factsheet and anarticle on your item.",
  tag2Props: { text5: "钻石研究文章", className: "tag-5" },
};
export const frame4Data = {
  rectangle69: "img/rectangle-69-2.png",
  name: "珍珠检测的方法",
  className: "rectangle-69",
  intro:
    "Encased in a lush trifold leather folder, the Premium Report is a three-page report containing information that caters specifically to your gemstone or jewellery set. Aarge blow-up photo in top-quality resolution rests between a factsheet and anarticle on your item.",
  tag2Props: { text5: "珍珠研究文章", className: "tag-6" },
};
export const frame5Data = {
  rectangle69: "img/rectangle-69-3.png",
  name: "GEMSTONE REPORT",
  className: "rectangle-69-4",
  intro:
    "The certificate identifies the variety of the gemstone, shape & cutting style, carat weight, color quality & trade name, measurements, transparency factor and major optical characteristics.",
  tag2Props: { text5: "钻石研究文章", className: "tag-7" },
};
export const frame6Data = {
  rectangle69: "img/rectangle-69-1.png",
  name: "总部实验室活动",
  className: "rectangle-69",
  intro:
    "Encased in a lush trifold leather folder, the Premium Report is a three-page report containing information that caters specifically to your gemstone or jewellery set. Aarge blow-up photo in top-quality resolution rests between a factsheet and anarticle on your item.",
  tag2Props: { text5: "彩色宝石研究文章", className: "tag-8" },
};

export const newsItemData20191227_1 = {
  title: "Lab-grown diamond by HPHT",
  headView: "img/news/20191227/1/3.jpg",
  tag: "合成钻石",
  content:
    "Our first synthetic diamond by High Pressure and Hight Temperature (HPHT) !  (aka 'Lab-grown') .   As gemologist working for a gemstone testing 'Lab', i would actually prefer to call them 'Factory-grown' ! What's wrong with 'Synthetic' anyway ?  In these pictures : typical 'Stop-sign' tension pattern and metallic inclusions.",
    images: [
      "img/news/20191227/1/1.jpg",
      "img/news/20191227/1/2.jpg",
      "img/news/20191227/1/3.jpg",
    ]
};
export const newsItemData20191227_2 = {
  title: "Emerald in Colombia",
  headView: "img/news/20191227/2/3.jpg",
  tag: "祖母绿",
  content:
    "Fantastic Colombian Emerald ! 23 ct, minor resin !  Very difficult to capture it's true magnificent color...  🙁  Hope you like nevertheless !!",
    images: [
      "img/news/20191227/2/1.jpg",
      "img/news/20191227/2/2.jpg",
      "img/news/20191227/2/3.jpg",
      "img/news/20191227/2/4.jpg",
      "img/news/20191227/2/5.jpg",
      "img/news/20191227/2/6.jpg",
    ]
};
export const newsItemData20191227_3 = {
  title: "Natural Bluish Green rough diamond",
  headView: "img/news/20191227/3/1.jpg",
  tag: "钻石",
  content:
    "Natural Bluish Green rough diamond.  Luckily with lots of radiation stains.  Very difficult to judge from spectra alone !  If polished, color origin will often be undisclosed.  <br /> <br /> FTIR shows type IaAB (with H1a radiation damage), UV-Vis-NIR confirms this with 415 nm.  Also clearly visible the radiation damage GR1 at 741nm.",
    images: [
      "img/news/20191227/3/1.jpg",
      "img/news/20191227/3/2.jpg",
      "img/news/20191227/3/3.jpg",
      "img/news/20191227/3/4.jpg",
    ]
};
export const newsItemData20191230_1 = {
  title: "Fantastic cloud patterns in diamond from Zimbabwe",
  headView: "img/news/20191230/1/1.jpg",
  tag: "津巴布韦钻石",
  content:
    "Fantastic cloud patterns in diamond from Zimbabwe ! (Second and third treated color... )",
    images: [
      "img/news/20191230/1/1.jpg",
      "img/news/20191230/1/2.jpg",
      "img/news/20191230/1/3.jpg",
    ]
};
export const newsItemData20191230_3 = {
  title: "Typical diamond crystal formation of Moissanite",
  headView: "img/news/20191230/3/1.jpg",
  tag: "莫桑石",
  content:
    "Pfff..... the market here is quiet during holiday season....  So plenty of time to post some interesting stuff today !  This one for my rough diamond trading friends.  Our Antwerp Mayor would say \"Caveat Emptor\" (Be aware, buyer) : rough diamonds offered for certification to the lab.  All show the typical diamond crystal formation (octahedron and dodecahedron and intermediate dissolution forms), however, they all tested as Moissanite !  It is not common to see moissanite in thess cubic form, as it is a hexagonal mineral (synthetically created).  Diamond Tester will be fooled by the high termal conductivity !  In fact, these crystal were bought as diamond by a large diamond company...  Visual indications are : strong doubling, anisotropic behaviour with polariscope, and 1 stone had hexagonal surface characteristics. Also scratch marks from (I assume) borazon needle. RAMAN easily identified them as Moissanite.  In red the Moissanite, in black the typical diamond spectrum with 1332 cm-1.",
    images: [
      "img/news/20191230/3/1.jpg",
      "img/news/20191230/3/2.jpg",
      "img/news/20191230/3/3.jpg",
      "img/news/20191230/3/4.jpg",
      "img/news/20191230/3/5.jpg",
    ]
};
export const newsItemData20191230_4 = {
  title: "A green diamond treated by HPHT",
  headView: "img/news/20191230/4/3.jpg",
  tag: "HTHP处理钻石",
  content:
    "A new day, a new challenge !  This diamond (from a parcel of 😎 showed strong green transmittance (or actually emittance), and it grew stronger when approaching the grading lamp...  Microscopic examination revealed graphitization of the inclusions, and the green transmission eminating from the graining planes.  On top of that a characteristic strong 'chalky' greenish fluorescence.  Further advanced testing revealed the stones to be IaAB (in FTIR) and in UV-VIS-NIR clearly H3 responsable for the green transmission.  But most interesting is the analysis of the N platelets in Infra-Red at approximate 1560 cm-1.  Deconvolution of the peak and the Full Width at Half Maximum (FWHM) clearly showes they are all treated by High Pressure and High Temperature (The '+' symbols) !  1 (rare) natural green-transmitter as reference sample, shows natural.  Thanx to Erwin Aelbrecht for the deconvolutions !",
    images: [
      "img/news/20191230/4/1.jpg",
      "img/news/20191230/4/2.jpg",
      "img/news/20191230/4/3.jpg",
      "img/news/20191230/4/4.jpg",
      "img/news/20191230/4/5.jpg",
      "img/news/20191230/4/6.jpg",
      "img/news/20191230/4/7.jpg",
    ]
};
export const newsItemData20200102_1 = {
  title: "An imitation pearl",
  headView: "img/news/20200102/1/4.jpg",
  tag: "pearl",
  content:
    "A new day, a new challenge !  This diamond (from a parcel of 😎 showed strong green transmittance (or actually emittance), and it grew stronger when approaching the grading lamp...  Microscopic examination revealed graphitization of the inclusions, and the green transmission eminating from the graining planes.  On top of that a characteristic strong 'chalky' greenish fluorescence.  Further advanced testing revealed the stones to be IaAB (in FTIR) and in UV-VIS-NIR clearly H3 responsable for the green transmission.  But most interesting is the analysis of the N platelets in Infra-Red at approximate 1560 cm-1.  Deconvolution of the peak and the Full Width at Half Maximum (FWHM) clearly showes they are all treated by High Pressure and High Temperature (The '+' symbols) !  1 (rare) natural green-transmitter as reference sample, shows natural.  Thanx to Erwin Aelbrecht for the deconvolutions !",
    images: [
      "img/news/20200102/1/4.jpg",
      "img/news/20200102/1/5.jpg",
      "img/news/20200102/1/6.jpg",
      "img/news/20200102/1/7.jpg",
    ]
};
export const newsItemData20200102_2 = {
  title: "Quench-crackled Verneuil synthetic ruby",
  headView: "img/news/20200102/2/1.jpg",
  tag: "ruby",
  content:
    "The year start well here at ALGT !  A ruby with 'chicken-wire' pattern of fingerprints...  This is what they call a 'Quench- crackled Verneuil synthetic'.  Here one has artificially created the fingerprints, in order to make the stone look worse than before, but at the same time 'more natural'.  A clean ruby without ANY inclusions is always suspicious.  Since the fractures are created after the crystal growth, the fractures are forced to follow the crystallographic (trigonal) directions of the stone : hence the pseudo-hexagonal pattern.  Curved growth-lines are present, but much less obvious due to the many fingerprints.",
    images: [
      "img/news/20200102/2/1.jpg",
      "img/news/20200102/2/2.jpg",
    ]
};
export const newsItemData20200126_1 = {
  title: "FEEG symposium",
  headView: "img/news/20200126/1/2.jpg",
  tag: "symposium",
  content:
    "A great weekend at Schoonhoven, The Netherlands, for the FEEG symposium.  Finally getting my long overdue diploma.  Fantastic speakers, great dinnerparty and what a charming town !",
    images: [
      "img/news/20200126/1/1.jpg",
      "img/news/20200126/1/2.jpg",
      "img/news/20200126/1/3.jpg",
      "img/news/20200126/1/4.jpg",
    ]
};
export const newsItemData20211224_1 = {
  title: "Kashmir (Pakistan)  purple pink sapphire",
  headView: "img/news/20211224/1/7.jpg",
  tag: "Kashmir",
  content:
    "Batakundi, Kashmir (Pakistan)  purple pink sapphire.",
    images: [
      "img/news/20211224/1/1.jpg",
      "img/news/20211224/1/2.jpg",
      "img/news/20211224/1/3.jpg",
      "img/news/20211224/1/4.jpg",
      "img/news/20211224/1/5.jpg",
      "img/news/20211224/1/6.jpg",
      "img/news/20211224/1/7.jpg",
      "img/news/20211224/1/8.jpg",
      "img/news/20211224/1/9.jpg",
    ]
};
export const newsItemData20220512_1 = {
  title: "unheated 8.80 carat sapphire originated from Sri Lanka",
  headView: "img/news/20220512/1/1.jpg",
  tag: "蓝宝石",
  content:
    "This stunning unheated 8.80 carat sapphire originated from Sri Lanka was recently brought in ALGT for research. Many thanks to Maxim from Metro Stones for his continuous support and for providing us with fantastic samples for our research department !",
    images: [
      "img/news/20220512/1/1.jpg",
      "img/news/20220512/1/2.jpg",
    ]
};
export const newsItemData20220517_1 = {
  title: "The chemical analysis and inclusion characteristics of an unusual purplish-blue 1.53 carat sapphire was submitted.",
  headView: "img/news/20220517/1/1.jpg",
  tag: "紫蓝色蓝宝石",
  content:
    "Recently an unusual purplish-blue 1.53 carat sapphire was submitted to ALGT for origin report.<br \>According to the chemical analysis and inclusion characteristics, we concluded that the stone is from the mine near the villages of Batakundi and Basil located in Pakistan controlled Kashmir.<br \>Very interesting stone! Take a look. 💎",
    images: [
      "img/news/20220517/1/1.jpg",
    ]
};
export const newsItemData20220523_1 = {
  title: "An interesting black diamond imitation.",
  headView: "img/news/20220523/1/1.jpg",
  tag: "黑钻石仿制品",
  content:
    "We recently had the chance to see an interesting black diamond imitation here at ALGT laboratory. It is in reality a polycrystalline material composed of tiny fragments of black diamonds glued together by a silicon based ‘matrix’. This material has been on the market since around 2000, but it is still quite unusual to see it in the lab.",
    images: [
      "img/news/20220523/1/1.jpg",
      "img/news/20220523/1/2.jpg",
    ]
};
export const newsItemData20220529_1 = {
  title: "Indications of heating present and insignificant residue in healed fissures.",
  headView: "img/news/20220529/1/1.jpg",
  tag: "裂缝 残留",
  content:
    "This lovely 1.82 carat padparadscha sapphire originated from Greenland was recently brought in ALGT for research. The magnified pictures of inclusions show that rose channels form “Star of David” pattern. Indications of heating present and insignificant residue in healed fissures.<br \><br \>Many thanks to Maxim from Metro Stones for his continuous support and for providing us with fantastic samples for our research department!",
    images: [
      "img/news/20220529/1/1.jpg",
    ]
};
export const newsItemData20220613_1 = {
  title: "The “cross-like” pattern is due to a simultaneous cubic and an octahedral growth.",
  headView: "img/news/20220613/1/2.jpg",
  tag: "十字形",
  content:
    "This HPHT Lab Grown diamond set in a ring shows a cross shape pattern under UV light source (EXA™). This “cross-like” pattern is due to a simultaneous cubic and an octahedral growth (at different growing speeds) which results in a different concentration of impurities causing this zoned fluorescence pattern.",
    images: [
      "img/news/20220613/1/1.jpg",
      "img/news/20220613/1/2.jpg",
      "img/news/20220613/1/3.jpg",
    ]
};
export const newsItemData20220615_1 = {
  title: "A beautiful extensive skeletal form of ultra-fine red-translucent haematite is intertwined in a light aquamarine.",
  headView: "img/news/20220615/1/1.jpg",
  tag: "红色半透明赤铁矿",
  content:
    "A beautiful extensive skeletal form of ultra-fine red-translucent haematite is intertwined by a few black ilmenite threads in a light aquamarine. Both minerals are syngenetic exsolutions.",
    images: [
      "img/news/20220615/1/1.jpg",
    ]
};
export const newsItemData20220627_1 = {
  title: "Intense purplish red diamond treated by HPHT and irradiation",
  headView: "img/news/20220627/1/1.jpg",
  tag: "红色半透明赤铁矿",
  content:
    "This week we received two natural diamonds with an intense purplish red color, treated by irradiation and annealed at high temperature. These diamonds showed a strong and ‘patchy’ green luminescence under the UVL due to the H3 centers, and a red color produced by (N-V)- centers.<br \>The combination of both defects results in a yellow color. <br \>What a spectacular luminescence display! We hope to see more of those! ",
    images: [
      "img/news/20220627/1/1.jpg",
      "img/news/20220627/1/2.jpg",
      "img/news/20220627/1/3.jpg",
    ]
};
export const newsItemData20220720_1 = {
  title: "This unheated 9.52 carat sapphire originated from Myanmar.",
  headView: "img/news/20220720/1/1.jpg",
  tag: "蓝宝石",
  content:
    "This gorgeous unheated 9.52 carat sapphire originated from Myanmar was recently brought in ALGT for research. Many thanks to Alexander from Baronian & Fils SA for his continuous support and for providing us with fantastic samples for our research department!",
    images: [
      "img/news/20220720/1/1.jpg",
      "img/news/20220720/1/2.jpg",
      "img/news/20220720/1/3.jpg",
      "img/news/20220720/1/4.jpg",
    ]
};
export const newsItemData20220727_1 = {
  title: "There are typical inclusions in this yellow HPHT-grown diamond.",
  headView: "img/news/20220727/1/3.jpg",
  tag: "蓝宝石",
  content:
    "ALGT (Antwerp) recently received several parcels of yellow diamonds, which were required to be identified and graded. <br \> <br \>After being tested one by one, we found one yellow HPHT laboratory-grown diamond hiding among a parcel of natural yellow diamonds.  <br \><br \>The weight of this yellow HPHT-grown diamond is 0.04 carat, and the color is vivid orangy yellow. <br \>There are typical inclusions in this yellow HPHT-grown diamond, including dark metallic rods and some irregular shapes.  Through FTIR testing, the yellow HPHT-grown diamond is type Ib with the main components of isolated nitrogen atoms. <br \><br \>When this yellow HPHT-grown diamond is illuminated by DiamondView (deep ultraviolet illumination at ~225 nm), it shows the ideal HPHT growth pattern. This “cross-like” pattern is due to a simultaneous cubic and an octahedral growth (at different growing speeds) which results in a different concentration of impurities causing this zoned fluorescence pattern. <br \><br \>The diamond research team of ALGT can assure that at present, ALGT Antwerp and Shanghai can precisely distinguish the natural, laboratory-grown, and treated diamonds.",
    images: [
      "img/news/20220727/1/1.jpg",
      "img/news/20220727/1/2.jpg",
      "img/news/20220727/1/3.jpg",
      "img/news/20220727/1/4.jpg",
      "img/news/20220727/1/5.jpg",
    ]
};
export const newsItemData20220809_1 = {
  title: "Showing results for recrystallization during cooling.",
  headView: "img/news/20220809/1/5.jpg",
  tag: "冷却过程中再结晶",
  content:
    "A 1.95 ct intense yellow (orangey) sapphire was recently submitted to our lab. The stone did not show any obvious heat-altered inclusions, besides blue color zoning related to bands of tiny particles (presumably rutile dust). However, the surface of the stone was more interesting and showed several areas where the stone’s surface had melted due to high temperature heating and subsequently re-crystallisation during cooling. On the pictures one can clearly see tiny gas bubbles in the re-crystallized areas.  FTIR showed the characteristic features of a Be-diffusion treatment with bands at approximately 3053-1 cm, and 2490-1 cm. ",
    images: [
      "img/news/20220809/1/1.jpg",
      "img/news/20220809/1/2.jpg",
      "img/news/20220809/1/3.jpg",
      "img/news/20220809/1/4.jpg",
      "img/news/20220809/1/5.jpg",
    ]
};
export const newsItemData20220826_1 = {
  title: "Halo in unheated Sri Lanka's sapphire.",
  headView: "img/news/20220826/1/4.jpg",
  tag: "斯里兰卡蓝宝石",
  content:
    "A 16.67 carat beautiful sapphire was brought to our lab for research purpose. Except for the long undissolved rutile needles (img3), this unheated Sri Lanka’s sapphire also has the black uraninite crystals with stress halo due to radiation (img 4). Check it out and let us know what you think! 💎 ",
    images: [
      "img/news/20220826/1/1.jpg",
      "img/news/20220826/1/2.jpg",
      "img/news/20220826/1/3.jpg",
      "img/news/20220826/1/4.jpg",
      "img/news/20220826/1/5.jpg",
    ]
};
export const newsItemData20221005_1 = {
  title: "A group of small zircon crystals in an unheated purplish pink sapphire from Madagascar.",
  headView: "img/news/20221005/1/2.jpg",
  tag: "紫粉色蓝宝石",
  content:
    "A group of small zircon crystals in an unheated purplish pink sapphire from Madagascar. This kind of zircon crystals are one of the characteristics of Madagascar sapphires from the central and southern part of the island. Very nice & bright colors.<br \><br \>Have a look! ",
    images: [
      "img/news/20221005/1/1.jpg",
      "img/news/20221005/1/2.jpg",
      "img/news/20221005/1/3.jpg",
      "img/news/20221005/1/4.jpg",
      "img/news/20221005/1/5.jpg",
    ]
};
export const newsItemData20240115_1 = {
  title: "ALGT at HongKong gemstone and jewelry show.",
  headView: "img/news/20240115/1/8.jpg",
  tag: "展会讯息 - 香港展",
  content:
    "ALGT at HongKong gemstone and jewelry show. <br\>ALGT at the Hongkong Jewelry and Gem Fair ! <br\>Great visibility, fantastic colleagues from our Shanghai branch, great promo materials, meeting old friends and industry legends. ",
    images: [
      "img/news/20240115/1/1.jpg",
      "img/news/20240115/1/2.jpg",
      "img/news/20240115/1/3.jpg",
      "img/news/20240115/1/4.jpg",
      "img/news/20240115/1/5.jpg",
      "img/news/20240115/1/6.jpg",
      "img/news/20240115/1/7.jpg",
      "img/news/20240115/1/8.jpg",
      "img/news/20240115/1/9.jpg",
      "img/news/20240115/1/10.jpg",
      "img/news/20240115/1/11.jpg",
      "img/news/20240115/1/12.jpg",
    ]
};
export const newsItemData20240115_2 = {
  title: "ALGT at Shanghai gemstone and jewelry show.",
  headView: "img/news/20240115/2/1.jpg",
  tag: "展会讯息 - 上海展",
  content:
    "As an independent international laboratory specializing in colorstone testing capabilities, ALGT also participated in this jewelry exhibition, mainly conducting in-depth visits and surveys on the domestic colorstone market and laboratory-grown diamond market.",
    images: [
      "img/news/20240115/2/1.jpg",
      "img/news/20240115/2/2.jpg",
      "img/news/20240115/2/3.jpg",
      "img/news/20240115/2/4.jpg",
      "img/news/20240115/2/5.jpg",
      "img/news/20240115/2/6.jpg",
    ]
};
export const newsItemData20240115_3 = {
  title: "ALGT in the 7th Geneva International Jewelry Exhibition",
  headView: "img/news/20240115/3/2.jpg",
  tag: "展会讯息 - 日内瓦展",
  content:
    "From November 2 to 5, 2023, the 7th Geneva International Jewelry Exhibition (GEMGENEVE) opened at the Palexpo Exhibition Center in Geneva. The exhibition area was 30,012 square meters, with a total of 619 exhibitors and 27,478 visitors. ALGT visited the exhibition as a professional.",
    images: [
      "img/news/20240115/3/1.jpg",
      "img/news/20240115/3/2.jpg",
    ]
};
export const newsItemData20240115_4 = {
  title: "ALGT in the Munich Show",
  headView: "img/news/20240115/4/2.jpg",
  tag: "展会讯息 - 慕尼黑展",
  content:
    "From November 2 to 5, 2023, the 7th Geneva International Jewelry Exhibition (GEMGENEVE) opened at the Palexpo Exhibition Center in Geneva. The exhibition area was 30,012 square meters, with a total of 619 exhibitors and 27,478 visitors. ALGT visited the exhibition as a professional.",
    images: [
      "img/news/20240115/4/1.jpg",
      "img/news/20240115/4/2.jpg",
      "img/news/20240115/4/3.jpg",
      "img/news/20240115/4/4.jpg",
    ]
};
export const newsItemData20240115_5 = {
  title: "We recently received a group of unheated rubies from Myanmar, Mong Hsu",
  headView: "img/news/20240115/5/4.jpg",
  tag: "无烧红宝",
  content:
    "We recently received a group of unheated rubies from Myanmar, Mong Hsu. They all have deep blue color zoning, combining with clouds of fine exsolved diaspore particles; heat treatment will remove the blue zoning.",
    images: [
      "img/news/20240115/5/1.jpg",
      "img/news/20240115/5/2.jpg",
      "img/news/20240115/5/3.jpg",
      "img/news/20240115/5/4.jpg",
      "img/news/20240115/5/5.jpg",
      "img/news/20240115/5/6.jpg",
      "img/news/20240115/5/7.jpg",
    ]
};
export const newsItemData20240115_6 = {
  title: "Koninklijk Instituut der Eliten van den Arbeid (KIEA) awarded the Gold Medal for Expert in Diamond !",
  headView: "img/news/20240115/6/1.jpg",
  tag: "马克获得劳动模范奖章",
  content:
    "Koninklijk Instituut der Eliten van den Arbeid (KIEA) awarded the Gold Medal for Expert in Diamond !  Highest professional award in Belgium !",
    images: [
      "img/news/20240115/6/1.jpg",
      "img/news/20240115/6/2.jpg",
    ]
};
export const newsItemData20240115_7 = {
  title: "ALGT recently received strings of ruby beads purchased by a client at the Hong Kong Jewellery Fair.",
  headView: "img/news/20240115/7/1.jpg",
  tag: "红宝石珠串",
  content:
    "ALGT recently received strings of ruby beads purchased by a client at the Hong Kong Jewellery Fair, which are vivid to deep red and quite transparent. His supplier told him that the strings are from Longido, Tanzania. The chemical analysis showed a high content of iron. Observing the inclusions with a darkfield microscope at 30-40 times magnification, these ruby beads have been heated, and there are borax residues in the fissures, which are common in heated rubies; I also noticed that some of the rubies have small flat bubbles in them, which means they have been treated by the FAPFH (flux‐assisted partial‐fissure‐healing) process. So the final conclusion is that these natural ruby strings have been heated with a minor to moderate amount of residue, in addition, a minor to moderate amount of glass filling used to reduce the visibility of the fissures and thus increase transparency. However, there is no lead glass filling.",
    images: [
      "img/news/20240115/7/1.jpg",
      "img/news/20240115/7/2.jpg",
      "img/news/20240115/7/3.jpg",
      "img/news/20240115/7/4.jpg",
      "img/news/20240115/7/5.jpg",
      "img/news/20240115/7/6.jpg",
      "img/news/20240115/7/7.jpg",
    ]
};
export const newsItemData20240115_8 = {
  title: "This amazing 3.03 cts and 3.15 cts demantoid pair originated from Russia was recently brought in ALGT for research.",
  headView: "img/news/20240115/8/2.jpg",
  tag: "翠榴石",
  content:
    `This amazing 3.03 cts and 3.15 cts demantoid pair originated from Russia was recently brought in ALGT for research. Since Russian demantoid often occurs as small grains with no well-developed crystal forms in the matrix, any faceted stone above one carat is considered rare. Demantoid is found in two types of geological deposits: contact metamorphic skarn-type and serpentinite-type.
    <br\><br\>These two demantoids were analysed at ALGT(Antwerp) with standard gemmological tools including a dark field microscope, Raman, UV-VIS-NIR. The chemical composition of both samples was measured by energy-dispersive X-ray fluorescence (EDXRF) spectroscopy.
    <br\><br\>Raman gave us results consistent with the reported physical properties for demantoid.
    <br\><br\>In both samples, the long, thin, curved chrysotile fibers (horsetails) characteristic of Russian demantoid were present.
    <br\><br\>The spectra of both samples were dominated by Cr3+ absorption bands at 625 and 640 nm , consistent with demantoid from other serpentinite-hosted deposits (e.g. China, Slovakia and Kerman in Iran, Italy, Pakistan). Both samples also showed very strong Fe3+ absorption between 430 and 450 nm.
    <br\><br\>EDXRF chemical data for the demantoid samples are presented in Figure 21-22. Fe was the predominant transition metal in the samples, followed by Cr, Mn, V and Ti.
    <br\><br\>Many thanks to Alexander from Baronian & Fils SA for his continuous support and for providing us with fantastic samples for our research department!`,
    images: [
      "img/news/20240115/8/1.jpg",
      "img/news/20240115/8/2.jpg",
      "img/news/20240115/8/3.jpg",
      "img/news/20240115/8/4.jpg",
      "img/news/20240115/8/5.jpg",
      "img/news/20240115/8/6.jpg",
      "img/news/20240115/8/7.jpg",
      "img/news/20240115/8/8.jpg",
      "img/news/20240115/8/9.jpg",
      "img/news/20240115/8/10.jpg",
      "img/news/20240115/8/11.jpg",
      "img/news/20240115/8/12.jpg",
      "img/news/20240115/8/13.jpg",
    ]
};
export const newsItemData20240115_9 = {
  title: "We are very proud to become the first platinum sponser for  F.E.E.G. Symposiums 2024 in Brussels.",
  headView: "img/news/20240115/9/2.png",
  tag: "成为FEEG2024布鲁塞尔研讨会的铂金赞助商",
  content:
    `We are very proud to become the first platinum sponser for  F.E.E.G. Symposiums 2024 in Brussels.
    <br\><br\>Federation for European Education in Gemmology – Symposiums 2024 – 2025
    <br\><br\>Below some info and dates on the next Symposiums of the Federation for European Education in gemmology: 
    <br\><br\>o The 24th Symposium will be organized in Barcelona on January the 13th 2024
    <br\><br\>o The 25th Symposium will be organized in Brussels on October the 19th 2024
    <br\><br\>o The 26th Symposium will be organized in Linz in September 2025
    <br\><br\>We found a “match made in heaven” as a venue for our 25th Symposium in Brussels – we will communicate on this topic soon. 
    <br\><br\>Meet our first Platinum Sponsor for the Brussels Symposium:
    <br\>·      Antwerp Laboratory for Gemstone Testing (ALGT)
    <br\><br\>About ALGT: The ALGT team of gemmologists consists out of highly qualified and trained industry experts with decades of experience providing customers total disclosure. The goal of ALGT is to assist, to protect and to serve both professionals and consumers. The CEO as well as five of his team members hold the EG Diploma issued by the Federation for European Education in Gemmology.
    <br\><br\>We are extremely proud to have former graduates acting as a sponsor for our Symposium in Belgium Stay Tuned!! 
    <br\><br\>Guy Lalous - Chairman of the Federation for European Education in Gemmology
    <br\><br\>Picture : CEO of ALGT and Chairman of FEEG after the signature of  the Sponsorship agreement on March the 22nd 2023`,
    images: [
      "img/news/20240115/9/1.jpg",
    ]
};
export const newsItemData20240327_1 = {
  title: "Recently a deep blue 0.71 carat sapphire (heated) was submitted to ALGT for origin report",
  headView: "img/news/20240327/1/1.png",
  tag: "",
  content:
    `Recently a deep blue 0.71 carat sapphire (heated) was submitted to ALGT for origin report.<br/><br/>
    According to the chemical analysis and inclusion characteristics, we concluded that the stone is from New South Wales, Australia. The orange crystal seems to float in the dark blue endless universe. Very interesting inclusion! Take a look. <br/>
    Many thanks to Andrea from BEAUCHAMP (Austria) for her continuous support and for providing us with diverse gemstones.<br/<br>`,
    images: [
      "img/news/20240327/1/1.png",
    ],
    links: [
      {
        url:"https://beauchamp.eu",
        img:"img/news/20240327/1/2.png",
      },
    ],
};
export const newsListData = [
  newsItemData20240115_9,
  newsItemData20240327_1,
  newsItemData20240115_8,
  newsItemData20240115_7,
  newsItemData20240115_6,
  newsItemData20240115_5,
  newsItemData20240115_4,
  newsItemData20240115_3,
  newsItemData20240115_2,
  newsItemData20240115_1,
  newsItemData20221005_1,
  newsItemData20220826_1,
  newsItemData20220809_1,
  newsItemData20220727_1,
  newsItemData20220720_1,
  newsItemData20220627_1,
  newsItemData20220615_1,
  newsItemData20220613_1,
  newsItemData20220529_1,
  newsItemData20220523_1,
  newsItemData20220517_1,
  newsItemData20220512_1,
  newsItemData20211224_1,
  newsItemData20200126_1,
  newsItemData20200102_2,
  newsItemData20200102_1,
  newsItemData20191230_4,
  newsItemData20191230_3,
  newsItemData20191230_1,
  newsItemData20191227_3,
  newsItemData20191227_2,
  newsItemData20191227_1,
];
  
export const newsData = {
  overlapGroup: "img/rectangle-84.png",
  title: "NEWS & LIBRARY",
  globalData: globalData,
  typesData: typesData,
  newsListData: newsListData,
};

export const serviceData = {
  overlapGroup: "img/rectangle-21-1.png",
  service: "SERVICE",
  viewMore: "View more ",
  viewMore2: ">>",

  diamondReportProps: {
    reportName: "DIAMOND REPORT",
    reportUrl: "/DiamondReport",
    rectangle: "img/service-1.jpeg",
    tag1: {
      rectangle: "img/service-1.jpeg",
      text: "The ALGT Natural Diamond Certificate provides a reliable and accurate documentation of a diamond’s identity and grade based on the internationally recognized diamond grading system. Each diamond is analyzed by several gemologists in order to provide the most accurate description of the diamond’s quality and characteristics.<br /><br />The carat weight, color, clarity and cut – commonly known as the 4C’s of each diamond - are clearly stated on each diamond certificate. Additional grading characteristics relating to the finish, girdle, culet and fluorescence are also detailed on the certificate.",
    },
    tag2: {
      rectangle: "img/service-3.png",
      text: "Laboratory Grown diamonds, also known as synthetic diamonds, are man-made stones.  This is achieved using the High Pressure High Temperature (HPHT) or Chemical Vapor Disposition (CVD) method. <br /><br />ALGT's LAB GROWN DIAMOND grading reports provide the same information as the ALGT Natural Diamond Report. <br /><br />However, the IDENTIFICATION result on the certificate is clearly stated as “Laboratory-Grown Diamond” to ensure that buyers and sellers can clearly see and understand that this is a synthetic diamond.",
    },
    tag3: {
      rectangle: "img/service-2.jpeg",
      text: "Full quality assessment, color grade and clarity plot.  Identifies natural vs. treated color. In order to determine whether a diamond is of natural or artificial colour.  <br /><br />Each ALGT Colored Diamond Grading Report contains the diamond’s information, as graded by the laboratorys gemologists. The information includes the stone’s shape and cutting style, measurements (in mm), weight (in metric carats), cut grade, proportions, color grade (according to the “Fancy” grade and its intensity), distribution of color, clarity grade, fluorescence and digital image(s) of the diamond.",
    },
    tag4: {
      rectangle: "img/service-4.jpeg",
      text: "We also specialise in rough diamond identification，and provide the yield calculation service.",
    }
  },
  gemstoneReportProps: {
    reportName: "GEMSTONE REPORT",
    reportUrl: "/GemstoneReport",
    rectangle: "img/service-5.jpeg",
    text: "ALGT offers full report with treatment disclosure (refer to the LMHC Enhancement Disclosure) & origin opinion for the listed major commercial gemstones: Ruby, Sapphire (Fancy Color Sapphire), Emerald, Spinel, Paraiba tourmaline. <br /><br />On Origin determination In order to determine the origin of a gemstone, the mineralogical and gemological properties collected during the testing is vital information. Our gemologists take this data to compare it with our vast database, narrowing down the specific gem bearing localities around the world.",
  },
  pearlReportProps: {
    reportName: "PEARL REPORT",
    reportUrl: "/PearlReport",
    rectangle: "img/fmzz.jpg",
    text: "Pearl Testing methods All pearls submitted are examined by direct X-radiography, and where necessary X-ray fluorescence techniques are also used.  The tests will ultimately confirm whether the pearls are natural, cultured, non-nucleated (also referred to as tissue nucleated cultured pearls) or imitation. Also, ALGT will use UV-Vis and PL to test whether the pearl color is natural or treated. <br /><br />Pearl Identification Report Includes the following information for loose, mounted or strung pearls: Quantity，Weight，Size，Shape，Color（Body Color & Overtone)，Pearl Type, Mollusk, Treatments, Lustre, Surface Quality.",
    
  },
  otherGemstoneReportProps: {
    reportName: "OTHER GEMSTONE REPORT",
    reportUrl: "/OtherGemstoneReport",
    rectangle: "img/service-7.png",
    text: "In addition to the identification and grading of precious colored stones and origin opinion, ALGT also provides identification and grading services for common colored stones such as chrysoberyl, garnet, tourmaline, beryl, peridot and jadeite.  <br /><br />Whilst ALGT cannot guarantee an opinion on origin for this category, we can offer a full report with treatment disclosure or, if the treatment is not easily determinable, an identification report at a reduced cost.",
  },
  premiumReportProps: {
    reportName: "PREMIUM REPORT",
    reportUrl: "/PremiumReport",
    rectangle: "img/hardcover-certificate-cover.jpg",
    images: [
      {url:require("/public/img/service-8-1.jpeg")},
      {url:require("/public/img/service-8-2.jpeg")},
      {url:require("/public/img/service-8-3.jpeg")},
      {url:require("/public/img/service-8-4.jpeg")},
    ],
    text: "Encased in a lush tri-fold leather folder, ALGT Premium Report is a three-page document containing information that describes your gemstone or jewelry set in detail.",
  },
  additionalService: "Additional Service",
  additional1Props: {
    className: "frame-18",
    rectangle: "img/rectangle-93.png",
    addition: "For a small additional fee, diamonds receiving an ALGT Diamond Grading report may also have their ID number laser inscribed on their girdle. This service is an extra service and is therefore not included in the ALGT basic grading service.",
  },
  additional2Props: {
    className: "frame-19",
    rectangle: "img/rectangle-94.png",
    addition: "The ALGT sealing system is the best way to ensure your loose diamonds are not tampered with after bring graded and on the way back to your possession. In a nutshell, the box is completely sealed and secured which ensures your peace of mind.",
  
  },
  additional3Props: {
    className: "frame-20",
    rectangle: "img/rectangle-95.png",
    addition: "ALGT offers a 3-hour verbal report service.",
  },
  termsTitle: "TERMS AND CONDITIONS",
  termsContent: "1. These Terms and Conditions for gem identification and grading activities (hereinafter the\"Terms andConditions\") stipulate the rights and obligations requesting identification and grading of gemstones.<br/><br/>2. ALGT provides identification and grading on species and variety, treatment, origin of gemstones informs of identification certificate, gemology report, grading report and verbal opinion(hereinafter, theservices).<br/><br/>3. ALGT will only provide testing requested by the client.",
  globalData: globalData,
};

export const contactData = {
  overlapGroup: "img/rectangle-21-1.png",
  contact: "CONTACT",
  addressName1: "Belgium - Antwerp",
  address1: "Diamond Plaza Hoveniersstraat 55 bus 80,2018",
  telephone1: "Telephone: +32 3 5350888",
  doorPic1: "img/rectangle-127.png",
  addressName2: "China - Shanghai",
  address2: "No.B39-41,Zijincheng Building,81 Lishui Road,Huangpu District.",
  telephone2: "Telephone: +86 13127578070",
  doorPic2: "img/rectangle-128.png",
  feePdf: "Report Price List Download",
  globalData: globalData,
};



export const regData = {
  rectangle21: "img/rectangle-144.png",
  phone: "+32 3 5350888",
  infoAlgtlabsCom: "info@algtlabs.com",
  title: "CUSTOMER REGISTRATION FORM",
  pleaseSendYourId: "Please send your ID/Passport copy and this form to info@algtlabs.com after filling out everything, thank you very much.<br />If you have more questions, please call us: +32 3 5350 888",
  companyName: "Company Name:",
  contactPerson: "Contact Person:",
  telephone: "Telephone:",
  mobilePhone: "Mobile Phone:",
  email: "Email:",
  address: "Address:",
  city: "City:",
  country: "Country:",
  vatNumber: "VAT Number:",
  idPassportCopy: "ID/Passport copy:",
  spanText1: "I have read and agree to the ‘ ",
  spanText2: "Terms and Conditions",
  spanText3: " ’ , and the ‘ ",
  spanText4: "Pricelist",
  spanText5: " ’ presented in this document.",
  clientSignature: "Client Signature",
  registrationFormDownload: "REGISTRATION FORM DOWNLOAD",
  logoContainer: "img/mask-group.png",
  globalData: globalData,
};




export const termsAndConditionsData = {
  overlapGroup: "img/banner-1920.png",
  globalData: globalData,
  title1: "TERMS AND CONDITIONS",
  content1: "1. These Terms and Conditions for gem identification and grading activities (hereinafter the\"Terms andConditions\") stipulate the rights and obligations requesting identification and grading of gemstones.<br/><br/>2. ALGT provides identification and grading on species and variety, treatment, origin of gemstones informs of identification certificate, gemology report, grading report and verbal opinion(hereinafter, theservices).<br/><br/>3. ALGT will only provide testing requested by the client.<br/><br/>4. This report or certificate contains only the characteristics and conditions of the article described hereinafter grading, testing, examination and analysis by using the techniques and equipment available to ALGTat the time of examination.<br/><br/>5. Neither ALGT nor any of its staff shall,at any time,be held responsible for any discrepancy which mayresult from the application of new technology or methods.<br/><br/>6. Determination of identity and other data is based on the chemical and physical properties and internalcharacteristics,using magnification,standardized viewing environment and light source(s), standard and(or)advanced gemological instruments as deemed necessary.<br/><br/>7. All gem identification and testing are conducted by experienced ALGT gemologists on independentbasis. Opinions may vary in terms of characteristics covered in this report,and results of the examinationmay differ upon (i) when,how and by whom the article is examined (ii)changes and improvements intechnology and equipment that enable the lab to detect,among other things,treatments previouslyundetectable, or alterations which become reversible,even if the process remains undetectable.<br/><br/>8. In the event of any claim by the client or any person for damage to the tested items,or damages resultingdirectly or indirectly from the Services,the liabilities of ALGT shall in no event exceed two(2) times theamount it receives from the client.<br/><br/>9. Neither the client nor any purchaser of the article(s)shall deem such gem certificate, gemology reportand verbal opinion as a guarantee,valuation or appraisal for tested items,and ALGT has no representationor warranty regarding the Services described herein.<br/><br/>10. All ALGT reports and certificates are printed on original paper and bear an official signature. Nocorrection or alteration of any form shall be accepted on the reports or certificates. An ALGT report orcertificate contains the identification of gemstones by photographic image(s), descriptions,measurements and weight,tested data,and states an opinion on their identity,treatment,quality and rarity,when applicable.",
  title2: "THE CLIENT ACKNOWLEDGES AND AGREES",
  content2: "1. Not all origins of gemstones are detectable;  <br/><br/>2. Gemstones can be treated, retreated, altered or otherwise processed after identification or testing by  ALGT;  <br/><br/>3. Advancement of technology may cause or result in a tested item being undetectable of its treatment and  (or) synthetic nature at the time of testing when no recognized testing method is publicly available.  <br/><br/>4. The client agrees not to hold ALGT and its employees liable for any loss or damage, special, incidental,  or consequential, etc.arising from any omission or description in an identification report or a grading  report resulting from human error, defective instruments, delay or other defects in connection with the  testing procedures, issuance or use of the identification report or the grading report, unless unless there is  fraud or willful misconduct by ALGT or its agents or employees.  <br/><br/>5. If a client fails to disclose all facts that are known by the client concerning the tested item for which the  client requested identification and grading, ALGT and its employees shall be exempted from any and all  loss, damage, or expense, etc. incurred as a result of identification and grading.  <br/><br/>6. Conclusion on the identity and treatments of gemstones is an opinion of the laboratory based on the  direct comparison of the findings with those obtained from the analysis of reference materials, as well as  those in published literature obtainable at the time of examination. As many mines around the world  produce gemstones that display similar properties, an opinion on the most probable geographic origin of  the examined gemstones cannot always be given.  <br/><br/>7. Unless expressly agreed otherwise, the client agrees not to hold ALGT liable for the loss or damage of  the submitted gemstone(s) resulting from risks that may occur during the transportation and delivery  process, including robbery and theft, during the examination process such as alterations of all kinds  including removal of fissure filling in the gem material; and while the gemstone is in the possession of  ALGT, including theft negligence and natural acts of God.  <br/><br/>8. ALGT may at its own discretion re-issue certificates within a period of one year from the issuance of the  original certificates upon client's request. ALGT has the right to retain the items which are not collected or  if the amount of certificates was not paid,within a period of 90 days after the article submitted to ALGT.  <br/><br/>9. The laboratory may refuse the issuance of a certificates at any time.  <br/><br/>10. ALGT and its employees and agents shall not be liable for any loss, damage or expense resulting from  any error in or omission from this certificate or from the issuance of or use of this certificate, even if the  loss, damage or expense was caused by or resulted from the negligence or other fault(except fraud, willful  misconduct or gross negligence)of ALGT or any of its employees or agents, and in any event ALGT and  its employees and agents shall not be liable for special or consequential damages resulting from any error  in or omission from this certificate caused by the acts of others, even if advised of the possibility of such  damages.  <br/><br/>11. All intellectual property rights belonging to ALGT, more particularly the contents of this Report /  Certificate, the name, the design, trademarks, service marks and logos of ALGT shall not be used in whole  or in part for any purpose whatsoever including for purposes of advertising, publicity or promotion, and this report may not be referred to as a guarantee, valuation or an appraisal. <br/><br/> ALGT Disclosure Comments for Colored Gemstones  <br/><br/>Ruby and Sapphire heat treatment terminology(2022)",
  table: {
    tr1: {
      td1: "Effect of Heat Treatment",
      td2: "No Heat",
      td3: "Heat",
      td4: "Heat with Residue in Fissure and Cavities",
    },
    tr2: {
      td1: "Amount of Residue",
      td2: "None",
      td3: "None",
      td4: "Minor",
      td5: "Moderate",
      td6: "Significant",
    },
    tr3: {
      td1: "Report Comment",
      td2: "No indication of heating.",
      td3: "Indications of heating.",
      td4: "Indications of heating.(minor)",
      td5: "Indications of heating.(moderate)",
      td6: "Indications of heating.(significant)",
    }
  },
  content3: "Indications of heating: Basic heat treatment, but with no residue detected within cavities and/or fissures.  <br/><br/>Rubies and sapphires that have been subjected to high-pressure, high-temperature (HPHT) treatment are  usually given this classification.  <br/><br/>Lead/ Bismuth: Lead and / or bismuth-rich , Vitreous residue was encounter within the tested item’s  fissures and /or cavities.  <br/><br/>SD： The item’s color has been altered via a surface diffusion process, whereby coloring ions have been  allowed to penetrate the stone to a minute depth. While this artificial color is stable, it may be removed  during any subsequent re-cutting and/or re-polishing.  <br/><br/>Light elements: The item’s color has been subtly or significantly altered via a bulk diffusion process,  whereby small coloring ions (e.g. beryllium, ect.) have been allowed to penetrate through the majority of  the stone.  <br/><br/>However, as the test for beryllium detection (i.e. LIBS ) causes minor damage to the surface of a gemstone,  this service is only carried out at the client’s request.  <br/><br/>1. The color of certain gemstone varieties can be altered by heating and/or irradiation.Such treatment is  hardly detectable by current instrumentation;  <br/><br/>2. The color of aquamarine can be altered by heating. Such treatment is hardly detectable by current  instrumentation;  <br/><br/>3. The color of morganite can be altered by heating or irradiation. Such treatment is hardly detectable by  current instrumentation.  <br/><br/>4. The color of demantoid can be altered by heating. Such treatment is hardly detectable by current  instrumentation.  <br/><br/>5. The color of rubellite can be altered by irradiation. Such treatment is hardly detectable by current  instrumentation.  <br/><br/>6. The color of Paraiba tourmaline can be altered by heating. Such treatment is hardly detectable by  current instrumentation.  <br/><br/>7. The color of zircon can be altered by heating and/or irradiation. Such treatment is hardly detectable by  current instrumentation.  <br/><br/>8. The color of tanzanite can be altered by heating. Such treatment is hardly detectable by current  instrumentation.",
};

export const newsDetailData = {
  overlapGroup: "img/banner-1920.png",
  globalData: globalData,
  newsListData:newsListData,
};

export const diamondReportData = {
  overlapGroup1: "img/rectangle-84.png",
  name1: "Diamond Report",
  theAlgtNaturalDia:
    "The ALGT Natural Diamond Certificate provides a reliable and accurate documentation of a diamond’s identity and grade based on the internationally recognized diamond grading system. Each diamond is analyzed by several gemologists in order to provide the most accurate description of the diamond’s quality and characteristics.<br /><br />The carat weight, color, clarity and cut – commonly known as the 4C’s of each diamond - are clearly stated on each diamond certificate. Additional grading characteristics relating to the finish, girdle, culet and fluorescence are also detailed on the certificate.",
    images: [
      {url:require("../public/img/certificate_36536663_00.png")},
      {url:require("../public/img/certificate_220338602_00.jpg")},
      {url:require("../public/img/certificate_21236145_00.png")},
      {url:require("../public/img/certificate_221320116_00.jpg")},
    ],
  x1: "img/diamond-report.jpeg",
  x3: "img/--3-2.png",
  name2: "Diamond Type Analysis",
  determinationOfDia:
    "Determination of diamond type – Ia, Ib, IIa or IIb. Results delivered on the report. Variety of testing services to determine diamond authenticity, natural vs. synthetic, natural vs. treated, or identify specific treatments.",
  coloredDiamondGradingReport: "Colored Diamond Grading Report",
  fullQualityAssessm:
    "Full quality assessment, color grade and clarity plot. Identifies natural vs. treated color. In order to determine whether a diamond is of natural or artificial colour, the following investigations are routinely performed on loose stones:Observation with a binocular microscope in dark field, transmitted light, polarized light, and immersion.FTIR spectroscopy to determine the type of diamond (type IaA, IaA/B, IaB, Ib, IIa, IIb). UV-visible-near-infrared spectroscopy of the diamond, Raman Photoluminescence spectroscopy of the diamond.",
  rectangle105: "img/rectangle-105.png",
  globalData: globalData,
};

export const gemstoneReportData = {
  overlapGroup1: "img/rectangle-88.png",
  title: "GEMSTONE REPORT",
  weOfferBothAVerb:
    "ALGT offers full report with treatment disclosure (refer to the LMHC Enhancement Disclosure) & origin opinion for the listed major commercial gemstones: Ruby, Sapphire (Fancy Color Sapphire), Emerald, Spinel, Paraiba tourmaline. <br /><br />On Origin determination In order to determine the origin of a gemstone, the mineralogical and gemological properties collected during the testing is vital information. Our gemologists take this data to compare it with our vast database, narrowing down the specific gem bearing localities around the world.",
  images: [
    {url:require("../public/img/certificate_17574570_00.png")},
    {url:require("../public/img/certificate_020302515_00.jpg")},
    {url:require("../public/img/certificate_020332410_00.jpg")},
    {url:require("../public/img/certificate_221346006_00.jpg")},
    {url:require("../public/img/certificate_820210118_00.jpg")},
  ],
  x1: "img/--1-3.png",
  x3: "img/--3-3.png",
  gcsGemstoneReports:
    "GCS gemstone reports include the following data based upon our judgment on the day of testing:",
  spanText1: "Report Number ",
  spanText2:
    "- Each report bears a unique digit number. This individual document number is critical to substantiate a report's authenticity.",
  spanText3: "Date",
  spanText4:
    " - The date on the report identifies the date when the item was processed for examination at our laboratory.",
  spanText5: "Object Description",
  spanText6: " - A brief description identifies an item being tested",
  spanText7: "Identification",
  spanText8:
    " - Descriptive identity of gemstone examination. Examined stones of natural formation, are identified as Natural before the items’ name. Items produced from a synthetic crystal, will bear the term Synthetic in front of the name (e.g. Synthetic Ruby). Stones that have undergone rigorous treatment will be marked as Treated.",
  spanText9: "Color Photo",
  spanText10:
    " - A full color image captured at the time of testing of item. Color and size may vary slightly from the actual item.",
  spanText11: "Shape / Cut",
  spanText12:
    " - Describes both the shape and the cut of the tested item. Shapes can be round, oval, octagonal, fancy, etc. Cut refers to the facet pattern, e.g. brilliant cut, step cut, polished etc.",
  spanText13: "Color",
  spanText14:
    " - Describes the spectral hue of the gemstone, e.g. red, blue, green, yellowish-green etc",
  spanText15: "Comment",
  spanText16:
    " - Describes observations noted on the gemstone such as possible enhancement (e.g. heat-treatment, clarity enhancement using oils or resins, dying etc.). In certain rare cases, determination of enhancement of the tested item is not possible. In these cases we will indicate Treatment undeterminable. Refer to the LMHC Enhancement Disclosure page for further details.",
  spanText17: "Origin Opinion",
  spanText18:
    " - GCS reports include a geographical origin opinion if such is determinable and requested. A gemstones’ Determination of Authenticity and Country of Origin is based on the testing of the physical and chemical properties of that stone. A conclusion is reached after examining the analysis of the internal characteristics (e.g. inclusions and growth structures) using standard gemmological devices and modern analytical instruments FTIR, UV & PL spectrometers, XRF …. The conclusion as to country of origin, authenticity, and treatment status of gemstones is an opinion of the laboratory based on direct comparisons of the findings with those obtained from the analyses of reference materials and published literature. To the best degree possible, GCS continuously updates this extensive knowledge base. Examined stones that do not produce sufficient data to arrive at an origin opinion will not have such information included.",
  globalData: globalData,
};

export const pearlReportData = {
  overlapGroup: "img/rectangle-89.png",
  title: "PEARL REPORT",
  pearlsSubmittedTo:
    "Pearls submitted to the laboratory take many forms, but most customers submit them as necklaces, rows or individual/lots of loose pearls.<br /><br />Mounted pearls can be tested, however, experience shows that most of the time it is less problematic to test pearls that are not mounted in rings, pendants, brooches or fancy necklaces, since the metal mounts of such items can prevent accurate X-radiography of the pearls. The laboratory staff usually advise customers whether X-radiography of an item is likely to be successful or not at the time of submission.",
    x1: "img/pearl-report-1.jpeg",
  x3: "img/x3.png",
  testingMethods: "Testing methods",
  allPearlsSubmitted:
    "All pearls submitted are examined by direct X-radiography, and where necessary X-ray fluorescence techniques are also used. These techniques provide the main tests used on all the pearls that pass through the laboratory. The tests will ultimately confirm whether the pearls are natural, cultured, non-nucleated (also referred to as tissue nucleated cultured pearls) or imitation.",
  name2: "Pearl Identification Report",
  includesTheFollowi:
    "Includes the following information for loose, mounted or strung pearls:<br />Quantity<br />Weight<br />Size<br />Shape<br />Color<br />Origin<br />Mollusk<br />Environment<br />Detectable treatments",
  rectangle105: "img/rectangle-105-1.png",
  globalData: globalData,
};

export const otherGemstoneReportData = {
  overlapGroup: "img/rectangle-91.png",
  title: "OTHER GEMSTONE REPORT",
  weAreHappyToCons:
    "In addition to the identification and grading of precious colored stones and origin opinion, ALGT also provides identification and grading services for common colored stones such as chrysoberyl, garnet, tourmaline, beryl, peridot and jadeite.<br /><br />Whilst ALGT cannot guarantee an opinion on origin for this category, we can offer a full report with treatment disclosure or, if the treatment is not easily determinable, an identification report at a reduced cost.",
  images: [
    {url:require("../public/img/certificate_ogr_000362900_00.jpg")},
    {url:require("../public/img/certificate_ogr_220362915_00.png")},
    {url:require("../public/img/certificate_ogr_420301816_00.png")},
    {url:require("../public/img/certificate_ogr_421300118_00.png")},
    {url:require("../public/img/certificate_ogr_620352716_00.png")},
  ],
  x1: "img/other-gemstone-report.jpeg",
  x3: "img/x3.png",
  globalData: globalData,
};

export const premiumReportData = {
  overlapGroup: "img/overlapGroup-s.png",
  title: "PREMIUM REPORT",
  encasedInALushTr:
    "Encased in a lush tri-fold leather folder, ALGT Premium Report is a three-page document containing information that describes your gemstone or jewelry set in detail.",
    rectangle: "img/service-8-1.jpeg",
    x1: "img/--1.png",
    x3: "img/--3.png",
  premiumService: "Premium Service",
  forASmallAddition:
    "For a small additional fee, diamonds receiving an ALGT Diamond Grading report may also have their ID number laser inscribed on their girdle. This service is an extra service and is therefore not included in the ALGT basic grading service.",
  rectangle93: "img/rectangle-93.png",
  rectangle95: "img/rectangle-95.png",
  rectangle94: "img/rectangle-94.png",
  theAlgtSealingSys:
    "The ALGT sealing system is the best way to ensure your loose diamonds are not tampered with after bring graded and on the way back to your possession. In a nutshell, the box is completely sealed and secured which ensures your peace of mind.",
  algtOffersA3Hour: "ALGT offers a 3-hour verbal report service.",
  globalData: globalData,
};
